// extracted by mini-css-extract-plugin
module.exports = {"outer":"square_outer__1lK3T","inner":"square_inner__RddfB"};